// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.save-buttons[data-v-bb7e0548]{display:flex;justify-content:end;gap:var(--default-grid-baseline)}`, "",{"version":3,"sources":["webpack://./src/components/Editor/SaveButtons.vue"],"names":[],"mappings":"AACA,+BACC,YAAA,CACA,mBAAA,CACA,gCAAA","sourcesContent":[".save-buttons{display:flex;justify-content:end;gap:var(--default-grid-baseline)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
